import React, { FC } from 'react'
import { MailOutlined, PhoneOutlined, UserOutlined } from '@ant-design/icons'
import { T } from '@transifex/react'

import { TDriverDriverTypeLabelMap } from 'src/api/consts'
import useDelayQuery from 'src/hooks/useDelayQuery'
import { useRoutingHistory } from 'src/reducers/routing/child-router-factory'
import { array } from 'src/utils/array'
import getFullName from 'src/utils/getFullName'

import {
  GetDriverInfoPopover,
  GetDriverInfoPopoverVariables,
} from './__generated__/types'
import { GET } from './api'
import { PopupContentProps } from '..'
import InfoCard from '../components/InfoCard'

const DriverPopup: FC<PopupContentProps> = ({ id }) => {
  const [history, { routingMap }] = useRoutingHistory()
  const { data: { driver } = {}, loading } = useDelayQuery<
    GetDriverInfoPopover,
    GetDriverInfoPopoverVariables
  >(
    GET,
    {
      variables: {
        id,
      },
    },
    300
  )

  const fullName = getFullName(driver?.user)

  return (
    <InfoCard
      title={fullName}
      avatarProps={{
        src: driver?.user.logo,
        color: driver?.user.color,
      }}
      headIcon={<UserOutlined />}
      headText={<T _str="Drivers" />}
      data={array(
        !!driver?.user.phoneNumber && {
          icon: <PhoneOutlined style={{ color: 'rgba(38, 38, 38, 0.5)' }} />,
          label: driver?.user.phoneNumber,
        },
        !!driver?.user.email && {
          icon: <MailOutlined style={{ color: 'rgba(38, 38, 38, 0.5)' }} />,
          label: driver?.user.email,
        }
      )}
      tags={
        driver?.driverType
          ? [
              {
                label: TDriverDriverTypeLabelMap[driver?.driverType],
              },
            ]
          : undefined
      }
      onView={() => {
        history.push(
          routingMap.app['fleet-management'].drivers[':driverId'](id)._
        )
      }}
      loading={loading}
    />
  )
}

export default DriverPopup
